import { ChevronDown } from "lucide-react";
import React, { useState } from "react";
import { Button } from "src/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "src/components/ui/dropdown-menu";

interface TrendsHeaderProps {
  className?: string;
  selectedClassName?: string;
  onIntervalChange?: (interval: number) => void;
  onDateChange?: (date: string) => void;
}

const TrendsHeader: React.FC<TrendsHeaderProps> = ({ className = 'bg-gray-201 text-black rounded-full', selectedClassName = 'bg-blue-500 text-white', onIntervalChange, onDateChange }) => {
  const [selectedInterval, setSelectedInterval] = useState<number>(7);
  const [selectedDate, setSelectedDate] = useState<string>('last_week');

  const handleIntervalChange = (interval: number) => {
    setSelectedInterval(interval);
    onIntervalChange?.(interval);
  };

  const handleDateChange = (date: string) => {
    setSelectedDate(date);
    onDateChange?.(date);
  };

  const intervalOptions = [
    { value: 1, label: '1 Day' },
    { value: 3, label: '3 Days' },
    { value: 5, label: '5 Days' },
    { value: 7, label: '7 Days' },
    { value: 14, label: '14 Days' },
    { value: 30, label: '30 Days' },
  ];

  return (
    <div className="flex flex-row items-center justify-between mb-6">
      <div>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              className={`ml-2 hover:opacity-65 bg-gray-201`}
              variant="ghost"
              size="med"
            >
              <ChevronDown className="w-4 h-4" />
              {selectedInterval}
              {' '}
              Days
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            {intervalOptions.map((option) => (
              <DropdownMenuItem
                key={option.value}
                onClick={() => handleIntervalChange(option.value)}
              >
                {option.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>

      </div>
      {/* <div className='flex items-center gap-2'>
        <Button
          className={`bg-gray-201 text-black rounded-full hover:opacity-65 ${selectedDate === 'last_week' ? selectedClassName : ''}`}
          variant="primary"
          size="med"
          onClick={() => handleDateChange('last_week')}
        >
          All time
        </Button>

        <Button
          className={`bg-gray-201 text-black rounded-full hover:opacity-65 ${selectedDate === 'last_month' ? selectedClassName : ''}`}
          variant="ghost"
          size="med"
          onClick={() => handleDateChange('last_month')}
        >
          Last month
        </Button>

        <Button
          className={`bg-gray-201 text-black rounded-full hover:opacity-65 ${selectedDate === 'last_month' ? selectedClassName : ''}`}
          variant="ghost"
          size="med"
          onClick={() => handleDateChange('last_month')}
        >
          Year to date
        </Button>


        <DateRangeModal
          className={className}
          selectedClassName={selectedClassName}
          selectedDate={selectedDate}
          onDateChange={handleDateChange}
        />
      </div> */}
    </div>
  );
};

export default TrendsHeader;
